import { Box, Button, Paper, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {pages} from "../../constants/pages";
import { useTranslation } from "react-i18next";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const BreadCrumb = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const isRTL = i18n.language?.startsWith('ar');
    const name = location.pathname.split("/")[1];
    const isNewsDetails = /^\/news\/[^/]+$/.test(location.pathname);
    let pageName = pages["/"+name];
    if (pageName) {
        const groupNameFallback = location.state?.groupName ?? (name === "order-details" ? t("notif_orderDetails") : "");
        const serviceNameFallback = location.state?.name ?? "";
        
        // Translate the page name if it's a key
        const translatedPageName = t(pageName);
        
        pageName = translatedPageName
            .replace("$groupName", groupNameFallback)
            .replace("$serviceName", serviceNameFallback)
            .replace(/\s*-\s*$/, "")
            .trim();

        if (!pageName.length) {
            pageName = undefined;
        }
    }
    const handleBackFromNews = () => {
        if (window.history.length > 1) {
            navigate(-1);
            return;
        }
        navigate('/news');
    };

    return (
        <Paper dir={isRTL ? 'rtl' : 'ltr'} sx={{ background: "#F9FAFC", overflow: "hidden" }} elevation={2}>
            {pageName && (
                <Box
                    sx={{
                        p: 1.875,
                        background: "#F9FAFC",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 1.25,
                    }}
                >
                    <Typography sx={{ fontWeight: "bold" }} variant="h6">{pageName}</Typography>
                    {isNewsDetails && (
                        <Button
                            onClick={handleBackFromNews}
                            size="small"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 700,
                                minWidth: 'unset',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.5,
                                direction: isRTL ? 'rtl' : 'ltr'
                            }}
                        >
                            <ArrowBackIosNewIcon sx={{ fontSize: 14, transform: isRTL ? 'rotate(180deg)' : 'none' }} />
                            {t('back', 'رجوع')}
                        </Button>
                    )}
                </Box>
            )}
        </Paper>
    )
}
export default BreadCrumb;